import { gsap, Power2 } from "gsap";

export default class CategoryTab {
  constructor() {
    this.init();
  }

  init = () => {
    this.setDomMap();
    this.bindEvents();
  };

  setDomMap = () => {
    this.window = $(window);
    this.body = $("body");
  };

  bindEvents = () => {
    const listItems = document.querySelectorAll(".category-block ul li");
    const listItemsFirst = document.querySelector(
      ".category-block ul li:first-child"
    );
    const infoElements = document.querySelectorAll(".category-block .info");
    const AssetElements = document.querySelectorAll(".category-block .image a");
    const infoElementsFirst = document.querySelector(
      ".category-block .info-wrap .info:first-child"
    );
    const imageElementsFirst = document.querySelector(
      ".category-block .image a:first-child"
    );

    listItemsFirst.classList.add("active");
    infoElementsFirst.classList.add("active");
    imageElementsFirst.classList.add("active");
    gsap.set(
      [
        infoElementsFirst.querySelector("h6"),
        infoElementsFirst.querySelector("p"),
        infoElementsFirst.querySelector(".primary-btn"),
      ],
      { opacity: 1, y: 0 }
    );

    listItems.forEach((item, index) => {
      item.addEventListener("click", function () {
        // Remove "active" class from all list items
        listItems.forEach((li) => li.classList.remove("active"));
        listItems.forEach((li) => li.classList.add("disable"));
        const activeInfo = document.querySelector(
          ".category-block .info.active"
        );
        // Add "active" class to the clicked list item
        this.classList.add("active");

        // Animate the active "info" element
        gsap.to(activeInfo.querySelector("h6"), {
          opacity: 0,
          y: -20,
          ease: Power2.easeOut,
          duration: 0.6,
        });

        gsap.to(activeInfo.querySelector("p"), {
          opacity: 0,
          y: -20,
          ease: Power2.easeOut,
          delay: 0.1,
          duration: 0.6,
        });

        gsap.to(activeInfo.querySelector(".primary-btn"), {
          opacity: 0,
          y: -20,
          delay: 0.2,
          ease: Power2.easeOut,
          duration: 0.6,
          onComplete: function () {},
        });

        infoElements.forEach((info) => info.classList.remove("active"));

        // Animate image
        const nextAssetBlock = AssetElements[index];
        nextAssetBlock.classList.add("next");

        const activeNewInfo = infoElements[index];
        activeNewInfo.classList.add("active");
        gsap.set(
          [
            activeNewInfo.querySelector("h6"),
            activeNewInfo.querySelector("p"),
            activeNewInfo.querySelector(".primary-btn"),
          ],
          { opacity: 0, y: 20 }
        );
        // Animate the active "next info" element
        gsap.to(activeNewInfo.querySelector("h6"), {
          opacity: 1,
          y: 1,
          delay: 0.4,
          ease: Power2.easeOut,
          duration: 0.6,
        });

        gsap.to(activeNewInfo.querySelector("p"), {
          opacity: 1,
          y: 1,
          delay: 0.6,
          ease: Power2.easeOut,
          duration: 0.6,
          onComplete: function () {
            AssetElements.forEach((asset) => {
              asset.classList.remove("active");
              if (asset.classList.contains("next")) {
                asset.classList.add("active");
                setTimeout(function () {
                  asset.classList.remove("next");
                  listItems.forEach((li) => li.classList.remove("disable"));
                }, 300);
              }
            });
          },
        });

        gsap.to(activeNewInfo.querySelector(".primary-btn"), {
          opacity: 1,
          y: 1,
          delay: 0.8,
          ease: Power2.easeOut,
          duration: 0.6,
        });
      });
    });
  };
}
